/** Renders a QR code as an <img> from arbitrary text (e.g. an otpauth:// URI),
 *  entirely client-side. Falls back to nothing if generation fails — the caller
 *  always also shows the raw secret for manual entry. */
import { useEffect, useState } from "react";
import QRCode from "qrcode";

export function QrCode({ text, size = 180 }: { text: string; size?: number }) {
  const [src, setSrc] = useState("");

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(text, { width: size, margin: 1 })
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {
        if (!cancelled) setSrc("");
      });
    return () => {
      cancelled = true;
    };
  }, [text, size]);

  if (!src) return null;
  return (
    <img
      src={src}
      alt="QR code"
      width={size}
      height={size}
      className="rounded-control border border-line"
    />
  );
}
